export default __webpack_public_path__ + "static/media/BOB_0192.f0d19613.JPG";